var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4836 21.5676C10.6325 21.7164 10.8185 21.7909 11.0232 21.7909C11.2278 21.7909 11.4139 21.7164 11.5627 21.5676C11.8604 21.2699 11.8604 20.7862 11.5627 20.4885L2.07433 11.0002L11.5627 1.5118C11.8604 1.21412 11.8604 0.730403 11.5627 0.432728C11.265 0.135054 10.7813 0.135054 10.4836 0.432728L0.437123 10.4606C0.139449 10.7583 0.139449 11.242 0.437123 11.5397L10.4836 21.5676Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.12f41f71.svg";
export { ForwardRef as ReactComponent };